import { contractReducers } from './contractReducers';
import { filterReducers } from './filtersReducers';
import { guaranteesReducers } from './guaranteesReducers';
import { guaranteesFiltersReducers } from './guaranteFiltersReducers';
import { priceUpdateReducers } from './priceUpdateReducers';
import { shoppingCartReducers } from './shoppingCartReducers';

export const reducers = {
  ...filterReducers,
  ...guaranteesReducers,
  ...shoppingCartReducers,
  ...contractReducers,
  ...priceUpdateReducers,
  ...guaranteesFiltersReducers,
};
